import { BaseHttpService } from "./BaseHttpService";

export interface ILoginParams {
  username: string;
  password: string;
  captcha: string;
}

export interface IAuthResult {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

export interface ISignupParams {
  username: string;
  email: string;
  password: string;
  birthday: number;
  validation_code: string;
  validation_token: string;
  preferences: string;
  niches: string;
  tags: string;
}

interface IResetPasswordParams {
  email: string;
}

interface IResetPasswordResult {
  message: string;
}

export default class AuthService extends BaseHttpService {
  private refreshPromise: Promise<IAuthResult> | null = null;

  public constructor(readonly url?: string) {
    super(url);
  }

  public login(params: ILoginParams): Promise<IAuthResult> {
    return this.post("/v2/auth0/login", params);
  }

  public async refresh(params: { refresh_token: string }): Promise<IAuthResult> {
    if (this.refreshPromise === null) {
      this.refreshPromise = this.post("/v2/auth0/refresh-token", params);
    }

    const result = await this.refreshPromise;
    this.refreshPromise = null;
    return result;
  }

  public signup(params: ISignupParams): Promise<IAuthResult> {
    return this.post("/v2/auth0/signup", params);
  }

  public resetPassword(params: IResetPasswordParams): Promise<IResetPasswordResult> {
    return this.post("/v2/auth0/reset-password", params);
  }
}
